import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import Chip from '@ui/Chip';

const EnvironmentLabel = ({isExpanded = false, environmentName}) => (
    <div className={classnames(
        'sidebar__environment-label',
        isExpanded
            ? 'sidebar__environment-label--expanded'
            : 'sidebar__environment-label--collapsed'
    )}>
        <Chip
            sx={{
                fontWeight: 700,
                height: 'auto',
            }}
            size='small'
            color='warning'
            label={isExpanded ? environmentName : environmentName.charAt(0).toUpperCase()}
        />
    </div>
);

EnvironmentLabel.propTypes = {
    isExpanded: PropTypes.bool,
    environmentName: PropTypes.string.isRequired,
};

export default EnvironmentLabel;
